// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"coupon"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4 19.9996H20V2.99963L17 4.99963L14.5 2.99963L12 4.99963L9.5 2.99963L7 4.99963L4 2.99963V19.9996Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 19.9996H20V2.99963L17 4.99963L14.5 2.99963L12 4.99963L9.5 2.99963L7 4.99963L4 2.99963V19.9996Z","strokeMiterlimit":2.41327,"stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M8 14.9996H16M12 10.9996H16M8 10.9996H8.00391V11.0035H8V10.9996Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-coupon')
export default class CouponIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'coupon',
    }
  }
}
